import React from 'react';
import BoatImagePlaceholder from '../../components/AdminBoatsPage/BoatImagePlaceholder';

const BoatEditForm = ({ formData, errors, categories, handleChange, handleFileChange, handleIntegerChange }) => {
  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    // Permite solo números y un punto decimal
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    // Asegura que solo haya un punto decimal
    const parts = sanitizedValue.split('.');
    if (parts.length > 2) {
      return;
    }
    // Limita a 2 decimales
    if (parts[1] && parts[1].length > 2) {
      return;
    }
    handleChange({
      target: {
        name,
        value: sanitizedValue
      }
    });
  };

  return (
    <>
      <div className="admin__modal-column-image">
        <BoatImagePlaceholder
          image={formData.main_image}
          onClick={() => document.getElementById('main-image-input').click()}
        />
        <input
          type="file"
          name="main_image"
          accept="image/*"
          id="main-image-input"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          className={errors.main_image ? 'error' : ''}
        />
        <label>Main Image: 1900x900 pixels - Max 2MB</label>
        <div className="error-message-container">
          <p className="error-message">{errors.main_image}</p>
        </div>
      </div>

      <div className="admin__modal-column">
        <div className="form-group">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Boat Name*"
            className={errors.name ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.name}</p>
          </div>
        </div>

        <div className="form-group">
          <div className="input-with-prefix">
            <span className="input-prefix">$</span>
            <input
              type="text"
              name="price"
              value={formData.price || ''}
              onChange={handlePriceChange}
              placeholder="Price"
              className={errors.price ? 'error' : ''}
            />
          </div>
          <div className="error-message-container">
            <p className="error-message">{errors.price}</p>
          </div>
        </div>

        <div className="form-group">
          <div className="input-with-prefix">
            <span className="input-prefix">$</span>
            <input
              type="text"
              name="discount_price"
              value={formData.discount_price || ''}
              onChange={handlePriceChange}
              placeholder="Discount Price"
              className={errors.discount_price ? 'error' : ''}
            />
          </div>
          <div className="error-message-container">
            <p className="error-message">{errors.discount_price}</p>
          </div>
        </div>

        <div className="form-group">
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Description"
            rows="3"
            className={errors.description ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.description}</p>
          </div>
        </div>
        <div className="form-group">
          <textarea
            name="note"
            value={formData.note || ''}
            onChange={handleChange}
            placeholder="Note (max 200 characters)"
            rows="2"
            maxLength={200}
            className={errors.note ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.note}</p>
          </div>
        </div>

        <div className="form-group">
          <select
            name="category_id"
            value={formData.category ? formData.category.id : ''}
            onChange={handleChange}
            className={`input-field ${errors.category ? 'error' : ''}`}
          >
            {categories && categories.map(category => (
              <option key={category.id} value={category.id}>{category.name}</option>
            ))}
          </select>
          <div className="error-message-container">
            <p className="error-message">{errors.category}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="text"
            name="length"
            value={formData.length || ''}
            onChange={handleIntegerChange}
            placeholder="Length (ft)"
            className={errors.length ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.length}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="text"
            name="capacity"
            value={formData.capacity || ''}
            onChange={handleIntegerChange}
            placeholder="Capacity (people)"
            className={errors.capacity ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.capacity}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="text"
            name="staterooms"
            value={formData.staterooms || ''}
            onChange={handleIntegerChange}
            placeholder="Staterooms"
            className={errors.staterooms ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.staterooms}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="text"
            name="bathrooms"
            value={formData.bathrooms || ''}
            onChange={handleIntegerChange}
            placeholder="Bathrooms"
            className={errors.bathrooms ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.bathrooms}</p>
          </div>
        </div>

        <div className="form-group form-group--checkbox">
          <label>
            <input
              type="checkbox"
              name="featured"
              checked={Boolean(formData.featured)}
              onChange={(e) =>
                handleChange({
                  target: {
                    name: 'featured',
                    value: e.target.checked,
                  },
                })
              }
            />
            Featured
          </label>
          <div className="error-message-container">
            <p className="error-message">{errors.featured}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoatEditForm;